var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

import request from './request';
import { createDeliveryRequest, createProductConfiguration, fetchQuantityFromData, getPromisedArrivalDate } from './shippingutil';
import uniqBy from 'lodash/uniqBy';
export var getShippingModelForCatalog = function getShippingModelForCatalog(fulfillerId) {
  var sellerid = "sellerId=" + fulfillerId;
  var sellerType = "sellerType=fulfillers";
  return request("https://shippingprice.financialflows.cimpress.io/api/v1/listPrices?" + sellerid + "&" + sellerType);
};
export var getShippingPriceForCatalog = function getShippingPriceForCatalog(priceModelId, inputSelection) {
  return request("https://shippingprice.financialflows.cimpress.io/api/v1/priceModels/" + priceModelId + "/evaluations", 'POST', inputSelection);
};
export var getShippingPrices = function getShippingPrices(sku, sellers, catalogPriceModelsPerSku, shipmentConfiguration, shippingInputs, priceMode) {
  return __awaiter(void 0, void 0, void 0, function () {
    var priceModels, listPrices, listPricesResult, index, priceModelId, seller, sellerId, sellerName;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          priceModels = {};
          listPrices = catalogPriceModelsPerSku[sku].map(function (catalogPriceModel) {
            var seller = catalogPriceModel.seller;
            var sellerId = seller.sellerId;
            return getShippingModelForCatalog(sellerId).catch(function () {
              return null;
            });
          });
          return [4
          /*yield*/
          , Promise.all(listPrices)];

        case 1:
          listPricesResult = _a.sent();

          for (index = 0; index < catalogPriceModelsPerSku[sku].length; index++) {
            priceModelId = listPricesResult[index][0] ? listPricesResult[index][0].priceModelId : null;
            seller = catalogPriceModelsPerSku[sku][index].seller;
            sellerId = seller.sellerId;
            sellerName = sellers[sellerId].sellerName;
            priceModels[sellerName] = priceModelId;
          }

          return [2
          /*return*/
          , prepareInputsForShippingPrices(sku, priceModels, shippingInputs, shipmentConfiguration, priceMode)];
      }
    });
  });
};
export var prepareInputsForShippingPrices = function prepareInputsForShippingPrices(sku, priceModels, shippingInputs, shipmentConfiguration, priceMode) {
  return __awaiter(void 0, void 0, void 0, function () {
    var shippingTime, destinationCountryCode, rowCount, quantities, packs, productionTimeResults, quantityKeys, shippingPricePromises, quantityMap, _loop_1, i, shippingPriceKeys, result, shippingPriceResults, index, price, totalShippingPrice, displayShippingPrice, currency;

    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          shippingTime = shipmentConfiguration.shippingTime, destinationCountryCode = shipmentConfiguration.destinationCountryCode;
          rowCount = shippingInputs.rowCount;
          quantities = shippingInputs.quantities, packs = shippingInputs.packs, productionTimeResults = shippingInputs.productionTimeResults;
          quantityKeys = Object.keys(quantities);
          shippingPricePromises = {};
          quantityMap = {};

          _loop_1 = function _loop_1(i) {
            if (!productionTimeResults[quantityKeys[i]] || !packs[quantityKeys[i]] || !quantities[quantityKeys[i]]) {
              Object.keys(priceModels).forEach(function (sellerName) {
                var resultKey = sellerName + "||" + quantityKeys[i];
                shippingPricePromises[resultKey] = {
                  error: 'Shipping attributes unavailable'
                };
              });
              return "continue";
            }

            var _a = productionTimeResults[quantityKeys[i]],
                productionTime = _a.productionTime,
                productionTimeUnits = _a.productionTimeUnits;
            var businessDaysToDelivery = void 0;
            if (productionTimeUnits === 'HH') businessDaysToDelivery = shippingTime - productionTime / 24 >= 0 ? shippingTime - productionTime / 24 : null;else {
              businessDaysToDelivery = shippingTime - productionTime >= 0 ? shippingTime - productionTime : null;
            }

            if (!businessDaysToDelivery) {
              Object.keys(priceModels).forEach(function (sellerName) {
                var resultKey = sellerName + "||" + quantityKeys[i];
                shippingPricePromises[resultKey] = {
                  error: "Shipping Time should be more than Production Time, Production Time : " + productionTime + " "
                };
              });
              return "continue";
            }

            var packQuantity = packs[quantityKeys[i]].quantity;
            var packWeightvalue = packs[quantityKeys[i]].weight.value; // const packWeightUnits = packs[index].weight.unit;

            var input = {};
            var inputSelections = [];
            var noOfPack = quantities[quantityKeys[i]] / packQuantity;
            inputSelections.push(createScope('pack', 'Shippable Pack Weight', packWeightvalue));
            inputSelections.push(createScope('pack', 'Shippable Pack Quantity', packQuantity));
            inputSelections.push(createScope('order', 'quantity', quantities[quantityKeys[i]]));
            inputSelections.push(createScope('fulfillment', 'productiontime', productionTime));
            inputSelections.push(createScope('fulfillment', 'productiontimeunits', productionTimeUnits)); // TODO packWeightUnits isn't availabe because of which call fails
            // inputSelections.push(createScope('shipment', 'weightunits', packWeightUnits));

            inputSelections.push(createScope('shipment', 'weight', noOfPack * packWeightvalue));
            inputSelections.push(createScope('destination', 'country', destinationCountryCode));
            input.InputSelections = inputSelections;
            Object.keys(priceModels).forEach(function (sellerName) {
              var resultKey = sellerName + "||" + quantityKeys[i];

              if (priceModels[sellerName]) {
                quantityMap[resultKey] = quantities[quantityKeys[i]];
                shippingPricePromises[resultKey] = getShippingPriceForCatalog(priceModels[sellerName], JSON.stringify(input)).catch(function () {
                  return {
                    error: 'Error in evaluating Shipping price model'
                  };
                });
              } else {
                quantityMap[resultKey] = quantities[quantityKeys[i]];
                shippingPricePromises[resultKey] = {
                  error: 'No Shipping price model'
                };
              }
            });
          };

          for (i = 0; i < rowCount; i++) {
            _loop_1(i);
          }

          shippingPriceKeys = Object.keys(shippingPricePromises);
          return [4
          /*yield*/
          , Promise.all(Object.values(shippingPricePromises))];

        case 1:
          result = _a.sent();
          shippingPriceResults = {};

          for (index = 0; index < shippingPriceKeys.length; index++) {
            if (result[index]) {
              price = result[index].price;

              if (price) {
                totalShippingPrice = price.totalAmount ? price.totalAmount : price.amount;
                displayShippingPrice = priceMode === 'total' ? totalShippingPrice : totalShippingPrice / quantityMap[shippingPriceKeys[index]];
                currency = price.currency;
                price = {
                  totalShippingPrice: totalShippingPrice,
                  displayShippingPrice: displayShippingPrice,
                  currency: currency
                };
                result[index].price = price;
              }

              shippingPriceResults[shippingPriceKeys[index].toLowerCase()] = result[index];
            }
          }

          return [2
          /*return*/
          , shippingPriceResults];
      }
    });
  });
};

var createScope = function createScope(scope, name, value) {
  return {
    Scope: scope,
    Name: name,
    Value: value
  };
};

export var getShippingPricesForContracts = function getShippingPricesForContracts(sku, sellers, manufacturingCostModels, contracts, shippingConfiguration, resolvedAttributes, priceMode, getState) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a, isProduction, logger, destinationCountryCode, city, destinationPostalCode, shippingTime, fulfillmentLocation, deliveryDate, deliveryRequestUrl, contractsResults, manufacturingCostResults, quantityMapContracts, quantityMapMaufacturing, productConfigurationUrlList, contractShippingKeys, manufacturingCostShippingKeys, contractsShippingResults, manufacturingCostShippingResults, result;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _a = getState().pricingGrid, isProduction = _a.isProduction, logger = _a.logger;
          destinationCountryCode = shippingConfiguration.destinationCountryCode, city = shippingConfiguration.city, destinationPostalCode = shippingConfiguration.destinationPostalCode, shippingTime = shippingConfiguration.shippingTime, fulfillmentLocation = shippingConfiguration.fulfillmentLocation;
          deliveryDate = getPromisedArrivalDate(shippingTime);
          return [4
          /*yield*/
          , createDeliveryRequest(destinationCountryCode, city, destinationPostalCode, isProduction, logger)];

        case 1:
          deliveryRequestUrl = _b.sent();

          if (!deliveryRequestUrl) {
            return [2
            /*return*/
            , null];
          }

          contractsResults = {};
          manufacturingCostResults = {};
          quantityMapContracts = {};
          quantityMapMaufacturing = {};
          return [4
          /*yield*/
          , getProductConfigUrlsForAttributes(sku, resolvedAttributes, logger)];

        case 2:
          productConfigurationUrlList = _b.sent();
          Object.entries(productConfigurationUrlList).forEach(function (_a) {
            var _b = __read(_a, 2),
                key = _b[0],
                value = _b[1];

            if (!value) {
              createEmptyShippingResultForContracts(sku, contractsResults, contracts, key, getState);
            } else {
              var productConfigUrl_1 = value.productConfigUrl,
                  quantity_1 = value.quantity;

              if (!productConfigUrl_1) {
                createEmptyShippingResultForContracts(sku, contractsResults, contracts, key, getState);
                createEmptyShippingResultForManufacturingCost(sku, manufacturingCostResults, manufacturingCostModels, key, getState);
              } else {
                contracts.forEach(function (contract) {
                  var updatedShippingKey = getSellerNameFromSellerId(sku, contract.seller.sellerId, getState) + "-" + contract.buyer.buyerId + "||" + key;
                  quantityMapContracts[updatedShippingKey] = quantity_1;
                  contractsResults[updatedShippingKey] = getShippingFromPricerService(updatedShippingKey, productConfigUrl_1, deliveryRequestUrl, deliveryDate, fulfillmentLocation, quantity_1, contract, isProduction);
                });
                manufacturingCostModels.forEach(function (manufacturingCostModel) {
                  var updatedShippingKey = getSellerNameFromSellerId(sku, manufacturingCostModel.seller.sellerId, getState) + "||" + key;
                  quantityMapMaufacturing[updatedShippingKey] = quantity_1;
                  manufacturingCostResults[updatedShippingKey] = getShippingFromPricerService(updatedShippingKey, productConfigUrl_1, deliveryRequestUrl, deliveryDate, fulfillmentLocation, quantity_1, manufacturingCostModel, isProduction);
                });
              }
            }
          });
          contractShippingKeys = Object.keys(contractsResults);
          manufacturingCostShippingKeys = Object.keys(manufacturingCostResults);
          contractsShippingResults = {};
          manufacturingCostShippingResults = {};
          return [4
          /*yield*/
          , Promise.all([Promise.all(Object.values(contractsResults)), Promise.all(Object.values(manufacturingCostResults))])];

        case 3:
          result = _b.sent();
          contractShippingKeys.forEach(function (key, index) {
            var price = result[0][index].price;

            if (price) {
              var totalShippingPrice = price.totalAmount ? price.totalAmount : price.amount;
              var displayShippingPrice = priceMode === 'total' ? totalShippingPrice : totalShippingPrice / quantityMapContracts[key];
              var currency = price.currency;
              price = {
                totalShippingPrice: totalShippingPrice,
                displayShippingPrice: displayShippingPrice,
                currency: currency
              };
              result[0][index].price = price;
            }

            contractsShippingResults[key.toLowerCase()] = result[0][index];
          });
          manufacturingCostShippingKeys.forEach(function (key, index) {
            var price = result[1][index].price;

            if (price) {
              var totalShippingPrice = price.totalAmount ? price.totalAmount : price.amount;
              var displayShippingPrice = priceMode === 'total' ? totalShippingPrice : totalShippingPrice / quantityMapMaufacturing[key];
              var currency = price.currency;
              price = {
                totalShippingPrice: totalShippingPrice,
                displayShippingPrice: displayShippingPrice,
                currency: currency
              };
              result[1][index].price = price;
            }

            manufacturingCostShippingResults[key.toLowerCase()] = result[1][index];
          });
          return [2
          /*return*/
          , {
            contractsShippingResults: contractsShippingResults,
            manufacturingCostShippingResults: manufacturingCostShippingResults
          }];
      }
    });
  });
};
export var getProductConfigurationUrl = function getProductConfigurationUrl(sku, attributes, quantity, logger) {
  return __awaiter(void 0, void 0, void 0, function () {
    var filteredAttributes, uniqueFilteredAttributes, filteredAttributesWithQuantity, productConfigurationRequest, productConfigUrl, validationUri, error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          filteredAttributes = attributes.filter(function (attribute) {
            return attribute && attribute.attributeKey && attribute.class && !(attribute.attributeKey.toLowerCase() === 'quantity' && (attribute.class.toLowerCase() === 'order' || attribute.class.toLowerCase() === 'tenant'));
          });
          uniqueFilteredAttributes = uniqBy(filteredAttributes, 'attributeKey');
          filteredAttributesWithQuantity = __spread(uniqueFilteredAttributes, [{
            attributeKey: 'quantity',
            attributeValue: quantity
          }]);
          productConfigurationRequest = createProductConfiguration(sku, filteredAttributesWithQuantity, true);
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , productConfigurationRequest];

        case 2:
          validationUri = _a.sent().validationUri;
          productConfigUrl = validationUri.substring(0, validationUri.lastIndexOf('/'));
          return [3
          /*break*/
          , 4];

        case 3:
          error_1 = _a.sent();
          logger.logError({
            message: 'Error in product configuration url',
            error: error_1
          }, 'Shipping');
          return [2
          /*return*/
          , {}];

        case 4:
          return [2
          /*return*/
          , {
            quantity: quantity,
            productConfigUrl: productConfigUrl
          }];
      }
    });
  });
};
export var getShippingFromPricerService = function getShippingFromPricerService(shippingKey, productConfigurationUrl, deliveryRequestUrl, requestedDeliveryDate, fulfillmentLocation, productionQuantity, contract, isProduction) {
  var buyerId = contract.buyer.buyerId;
  var buyerType = contract.buyer.buyerType;
  var sellerId = contract.seller.sellerId;
  var sellerType = contract.seller.sellerType;
  var pricerServiceUrl = 'https://pricer.cimpress.io/v2/shippingprice';
  var fulfillmentLocationUrl = 'https://fulfillmentlocation.trdlnk.cimpress.io/v1/fulfillmentlocations';
  var nonPrdFulfillmentLocationUrl = 'https://fulfillmentlocation.trdlnk.cimpress.io/v1/fulfillmentlocations/';
  var fulfillmentLocationRootUrl = isProduction ? fulfillmentLocationUrl : nonPrdFulfillmentLocationUrl;
  var fulfillerUrl = fulfillmentLocationRootUrl + "/" + fulfillmentLocation.value; // eslint-disable-next-line max-len

  var query = "?sellerId=" + sellerId + "&sellerType=" + sellerType + "&buyerId=" + buyerId + "&buyerType=" + buyerType + "&productConfigurationUrl=" + productConfigurationUrl + "&deliveryRequestUrl=" + deliveryRequestUrl + "&fulfillmentLocationUrl=" + fulfillerUrl + "&promisedArrivalDate=" + requestedDeliveryDate + "&quantity=" + productionQuantity;
  return request(pricerServiceUrl + query).then(function (result) {
    result.price.amount = result.price.totalAmount;
    return result;
  }).catch(function () {
    return {
      error: 'No Shipping Cost found'
    };
  });
};
export var createEmptyShippingResultForContracts = function createEmptyShippingResultForContracts(sku, shippingResult, contracts, shippingKey, getState) {
  for (var i = 0; i < contracts.length; i++) {
    var updatedShippingKey = getSellerNameFromSellerId(sku, contracts[i].seller.sellerId, getState) + "-" + contracts[i].buyer.buyerId + "||" + shippingKey;
    shippingResult[updatedShippingKey] = {
      error: 'Error in Product Configuration'
    };
  }
};
export var createEmptyShippingResultForManufacturingCost = function createEmptyShippingResultForManufacturingCost(sku, shippingResult, manufacturingCostModels, shippingKey, getState) {
  for (var i = 0; i < manufacturingCostModels.length; i++) {
    var updatedShippingKey = getSellerNameFromSellerId(sku, manufacturingCostModels[i].seller.sellerId, getState) + "||" + shippingKey;
    shippingResult[updatedShippingKey] = {
      error: 'Error in Product Configuration'
    };
  }
};
export var getSellerNameFromSellerId = function getSellerNameFromSellerId(sku, sellerId, getState) {
  var sellers = getState().priceExplorerGrid.sellers;
  return sellers[sku][sellerId].sellerName;
};
export var getProductConfigUrlsForAttributes = function getProductConfigUrlsForAttributes(sku, resolvedAttributes, logger) {
  return __awaiter(void 0, void 0, void 0, function () {
    var productConfigPromises, productConfigKeys, promiseResults, productConfigResults;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          productConfigPromises = {};
          resolvedAttributes.forEach(function (resolvedAttribute) {
            var key = resolvedAttribute.key;
            var productConfigKey = key + "||";
            var totalValues = resolvedAttribute.values.length;

            if (totalValues === 0) {
              productConfigPromises[productConfigKey] = null;
            } else if (totalValues === 1) {
              var attributes = resolvedAttribute.values[0].attributes;
              var quantity = attributes ? fetchQuantityFromData(attributes) : null;

              if (!quantity) {
                productConfigPromises[productConfigKey] = null;
              } else {
                productConfigPromises[productConfigKey] = getProductConfigurationUrl(sku, attributes, quantity, logger);
              }
            } else {
              // In case of dual pivot
              var values = resolvedAttribute.values;
              values.forEach(function (value) {
                var dualPivotKey = value.key; // eslint-disable-next-line prefer-destructuring

                dualPivotKey = dualPivotKey.split('|')[1];
                dualPivotKey = productConfigKey + dualPivotKey;
                var attributes = value.attributes;
                var quantity = attributes ? fetchQuantityFromData(attributes) : null;

                if (!quantity) {
                  productConfigPromises[dualPivotKey] = null;
                } else {
                  productConfigPromises[dualPivotKey] = getProductConfigurationUrl(sku, attributes, quantity, logger);
                }
              });
            }
          });
          productConfigKeys = Object.keys(productConfigPromises);
          return [4
          /*yield*/
          , Promise.all(Object.values(productConfigPromises))];

        case 1:
          promiseResults = _a.sent();
          productConfigResults = {};
          productConfigKeys.forEach(function (key, index) {
            productConfigResults[key] = promiseResults[index];
          });
          return [2
          /*return*/
          , productConfigResults];
      }
    });
  });
};